import { motion } from "framer-motion";
import { Zap } from "lucide-react";

const TopBanner = () => {
  return (
    <div className="fixed top-[64px] left-0 right-0 z-[49] bg-secondary text-secondary-foreground overflow-hidden">
      <motion.div
        className="flex items-center justify-center gap-2 py-2 px-4 text-sm font-semibold whitespace-nowrap"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <motion.span
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 2 }}
        >
          <Zap className="w-4 h-4 fill-current" />
        </motion.span>
        <span>Twoja strona gotowa w 24h od zamówienia!</span>
        <motion.span
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 2 }}
        >
          <Zap className="w-4 h-4 fill-current" />
        </motion.span>
      </motion.div>
    </div>
  );
};

export default TopBanner;
